import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';
import Loader from '../../components/Loader';
import RnFArticle from '../../components/RnFArticle';
import RnFEatery from '../../components/RnFEatery';
import RnFExperience from '../../components/RnFExperience';
import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';
// import ClearIcon from '@material-ui/icons/Clear';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Grid from '@material-ui/core/Grid';
import {
  Typography,
  GridListTile,
  GridList,
  ListSubheader,
  Button,
  TextField,
  Icon,
} from '@material-ui/core';
import { validateEmpty } from '../AddEditContributor/Factory';

const CardsSlider = ({ cards, history, className, onRemove }) => {
  console.log(cards);
  let displayCards = [];
  cards.map((card, i) => {
    switch (card.resourceType) {
      case 'LISTICLE':
        displayCards.push(
          <Grid item xs={4}>
            <div key={'card-div' + i} className={className}>
              <RnFArticle
                key={'card' + i}
                name={card.title}
                curatedBy={card.owner.firstName + ' ' + card.owner.lastName}
                summary={card.description}
                img={card.imageUrl}
                id={card.id}
                removable={true}
                onRemove={onRemove}
              />
            </div>
          </Grid>
        );
        return 0;
      case 'EATERY':
        displayCards.push(
          <Grid item xs={4}>
            <div key={'card-div' + i} className={className}>
              <RnFEatery
                key={'card' + i}
                name={card.title}
                img={card.imageUrl}
                location={card.location}
                cuisine={card.cuisines}
                dishes={card.mustTryDishes}
                data={card}
                removable={true}
                onRemove={onRemove}
              />
            </div>
          </Grid>
        );
        return 0;
      case 'STORY':
        displayCards.push(
          <Grid item xs={4}>
            <div key={'card-div' + i} className={className}>
              <RnFArticle
                key={'card' + i}
                name={card.title}
                curatedBy={card.owner.firstName + ' ' + card.owner.lastName}
                summary={card.description}
                img={card.imageUrl}
                id={card.id}
                removable={true}
                onRemove={onRemove}
              />
            </div>
          </Grid>
        );
        return 0;
      case 'EXPERIENCE':
        displayCards.push(
          <Grid item xs={4}>
            <div key={'card-div' + i} className={className}>
              <RnFExperience
                key={'card' + i}
                name={card.title}
                expType={card.experienceType}
                summary={card.description}
                img={card.imageUrl}
              />
            </div>
          </Grid>
        );
        return 0;
      default:
        return 0;
    }
  });
  return (
    <div style={{ height: 'auto', overflowY: 'scroll', overflowX: 'hidden' }}>
      <Grid container spacing={24}>
        {' '}
        {displayCards}
      </Grid>
    </div>
  );
};

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    display: 'inline-grid',
    width: '60%',
  };
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  about_body: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit + 7,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  button: {
    backgroundColor: 'transparent',
    border: '1px solid #aeaeae',
    textAlign: 'left',
    borderRadius: '5px',
    margin: '0px',
  },
  createButton: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: 'none',
  },
  icon: {
    verticalAlign: 'middle',
  },
  card: {
    border: '1px solid #aeaeae',
    borderRadius: '5px',
    margin: '10px 0px',
  },
});

// const response = [
//   {
//     bookmarks: [
//       {
//         id: 1149,
//         imageUrl:
//           'https://talkingstreet.in/wp-content/uploads/2017/11/Kentacky-Chicken-Corner-Dosa-and-Chicken-Curry-Richmond-Road-Bangalore-Credits-Zomato.jpg',
//         description: 'Buttery, soft dosas with spicy chicken curry',
//         linkTitle: 'kentacky-chicken-corner-bangalore',
//         title: 'Kentacky Chicken Corner, Bangalore',
//         resourceType: 'EATERY',
//         tags: [],
//         location: {
//           fullAddress: '10, Sampangi Tank Road, Richmond Road, Bangalore',
//           locality: 'Bangalore',
//           latitude: 12.96604784036018,
//           longitude: 77.59511862037652,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [
//           {
//             id: 571,
//             name: 'Karnataka-style South-Indian',
//           },
//           {
//             id: 577,
//             name: 'Kannadiga',
//           },
//           {
//             id: 585,
//             name: 'Special Cuisine - Indian',
//           },
//           {
//             id: 588,
//             name: 'Biryani',
//           },
//           {
//             id: 589,
//             name: 'South Indian',
//           },
//         ],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },

//       {
//         id: 1162,
//         imageUrl:
//           'https://images.unsplash.com/photo-1426869884541-df7117556757?fit=crop&w=700&q=60',
//         description: 'Delicious crepes with sweet and savoury fillings',
//         linkTitle: 'lot-like-crepes-koramangala-bangalore',
//         title: 'Lot Like Crepes, Bangalore',
//         resourceType: 'EATERY',
//         tags: [],
//         location: {
//           fullAddress: '203, 1st Main, Koramangala, 7th Block, Bangalore',
//           locality: 'Koramangala, Bangalore',
//           latitude: 12.936724,
//           longitude: 77.6134749,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [
//           {
//             id: 574,
//             name: 'Desserts',
//           },
//           {
//             id: 596,
//             name: 'Continental',
//           },
//         ],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//       {
//         id: 1165,
//         imageUrl:
//           'http://talkingstreet.in/wp-content/uploads/2015/10/Sri-Sai-Durga-99-Variety-Dosas-dosa-CMH-Road-Bangalore-4.jpg',
//         description: 'Dummy Value',
//         linkTitle: 'sri-sai-durga-99-varieties-dosa-cmh-road',
//         title: 'Sri Sai Durga 99 Varieties Dosa',
//         resourceType: 'EATERY',
//         tags: [],
//         location: {
//           fullAddress:
//             '726, Chinmaya Mission Hospital Rd, First Stage, Defence Colony, Indiranagar, Bengaluru, Karnataka 560038, India',
//           locality: 'Indira Nagar, CMH Road',
//           latitude: 12.978520750072,
//           longitude: 77.646327620963,
//           directionLandmarks:
//             'Sri Sai 99 Varieties Dosa is just in front of Chinmaya Mission Hoaspital on CHM Road. If coming from KFC Junction, its 500m ahead to the right side. If coming from 80 feet road take the road opposite to Aeronotical Technologies  which is the CMH road, outlet is right in front of Chinmaya Mission Hoaspital to your left. ',
//           placeId: null,
//         },
//         cuisines: [
//           {
//             id: 589,
//             name: 'South Indian',
//           },
//           {
//             id: 606,
//             name: 'South Indian Tiffin',
//           },
//         ],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//     ],
//     id: 0,
//     name: 'First Board',
//   },
//   {
//     bookmarks: [
//       {
//         id: 7033,
//         imageUrl:
//           'http://talkingstreet.in/wp-content/uploads/2015/04/slider3.jpg',
//         description: null,
//         linkTitle: 'explorer-diaries-food-trail-in-indira-nagar',
//         title: 'Explorer Diaries: Food trail in Indira Nagar',
//         resourceType: 'STORY',
//         tags: null,
//         location: {
//           fullAddress: null,
//           locality: 'Indira Nagar',
//           latitude: 0,
//           longitude: 0,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//       {
//         id: 7035,
//         imageUrl:
//           'http://talkingstreet.in/wp-content/uploads/2015/05/Mumbai-99-Variety-of-Dosa-Facade4-Bannerghatta-Rd-Bangalore1.jpg',
//         description: null,
//         linkTitle: 'food-street-in-koramangala',
//         title: 'Food Street in Koramangala',
//         resourceType: 'STORY',
//         tags: null,
//         location: {
//           fullAddress: null,
//           locality: 'Koramangala, Bangalore',
//           latitude: 0,
//           longitude: 0,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [
//           {
//             id: 555,
//             name: 'Bengali Sweets',
//           },
//           {
//             id: 562,
//             name: 'Sandwiches',
//           },
//           {
//             id: 563,
//             name: 'Mumbai Street Food',
//           },
//           {
//             id: 598,
//             name: 'Chinese',
//           },
//           {
//             id: 601,
//             name: 'Momos',
//           },
//           {
//             id: 612,
//             name: 'Pani Puri',
//           },
//         ],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//       {
//         id: 7035,
//         imageUrl:
//           'http://talkingstreet.in/wp-content/uploads/2015/05/Mumbai-99-Variety-of-Dosa-Facade4-Bannerghatta-Rd-Bangalore1.jpg',
//         description: null,
//         linkTitle: 'food-street-in-koramangala',
//         title: 'Food Street in Koramangala',
//         resourceType: 'STORY',
//         tags: null,
//         location: {
//           fullAddress: null,
//           locality: 'Koramangala, Bangalore',
//           latitude: 0,
//           longitude: 0,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [
//           {
//             id: 555,
//             name: 'Bengali Sweets',
//           },
//           {
//             id: 562,
//             name: 'Sandwiches',
//           },
//           {
//             id: 563,
//             name: 'Mumbai Street Food',
//           },
//           {
//             id: 598,
//             name: 'Chinese',
//           },
//           {
//             id: 601,
//             name: 'Momos',
//           },
//           {
//             id: 612,
//             name: 'Pani Puri',
//           },
//         ],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//     ],
//     id: 1,
//     name: 'Second Board',
//   },
//   {
//     bookmarks: [
//       {
//         id: 7033,
//         imageUrl:
//           'http://talkingstreet.in/wp-content/uploads/2015/04/slider3.jpg',
//         description: null,
//         linkTitle: 'explorer-diaries-food-trail-in-indira-nagar',
//         title: 'Explorer Diaries: Food trail in Indira Nagar',
//         resourceType: 'STORY',
//         tags: null,
//         location: {
//           fullAddress: null,
//           locality: 'Indira Nagar',
//           latitude: 0,
//           longitude: 0,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//       {
//         id: 7035,
//         imageUrl:
//           'http://talkingstreet.in/wp-content/uploads/2015/05/Mumbai-99-Variety-of-Dosa-Facade4-Bannerghatta-Rd-Bangalore1.jpg',
//         description: null,
//         linkTitle: 'food-street-in-koramangala',
//         title: 'Food Street in Koramangala',
//         resourceType: 'STORY',
//         tags: null,
//         location: {
//           fullAddress: null,
//           locality: 'Koramangala, Bangalore',
//           latitude: 0,
//           longitude: 0,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [
//           {
//             id: 555,
//             name: 'Bengali Sweets',
//           },
//           {
//             id: 562,
//             name: 'Sandwiches',
//           },
//           {
//             id: 563,
//             name: 'Mumbai Street Food',
//           },
//           {
//             id: 598,
//             name: 'Chinese',
//           },
//           {
//             id: 601,
//             name: 'Momos',
//           },
//           {
//             id: 612,
//             name: 'Pani Puri',
//           },
//         ],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//       {
//         id: 7035,
//         imageUrl:
//           'http://talkingstreet.in/wp-content/uploads/2015/05/Mumbai-99-Variety-of-Dosa-Facade4-Bannerghatta-Rd-Bangalore1.jpg',
//         description: null,
//         linkTitle: 'food-street-in-koramangala',
//         title: 'Food Street in Koramangala',
//         resourceType: 'STORY',
//         tags: null,
//         location: {
//           fullAddress: null,
//           locality: 'Koramangala, Bangalore',
//           latitude: 0,
//           longitude: 0,
//           directionLandmarks: '',
//           placeId: null,
//         },
//         cuisines: [
//           {
//             id: 555,
//             name: 'Bengali Sweets',
//           },
//           {
//             id: 562,
//             name: 'Sandwiches',
//           },
//           {
//             id: 563,
//             name: 'Mumbai Street Food',
//           },
//           {
//             id: 598,
//             name: 'Chinese',
//           },
//           {
//             id: 601,
//             name: 'Momos',
//           },
//           {
//             id: 612,
//             name: 'Pani Puri',
//           },
//         ],
//         mustTryDishes: null,
//         city: {
//           id: 626,
//           name: 'Bangalore',
//           about: null,
//           localCuisines: [
//             {
//               id: 577,
//               name: 'Kannadiga',
//             },
//           ],
//           mainImage: {
//             id: 627,
//             uri:
//               'https://publish.talkingstreet.in:8443/wp-content/uploads/2015/03/Mahalakshmi-Tiffin-Room-Masala-Dosa-Gandhi-Bazaar-Bangalore.jpg',
//             name: null,
//             description: null,
//             picCredits: null,
//           },
//         },
//       },
//     ],
//     id: 1,
//     name: 'Third Board',
//   },
// ];

class MyBoards extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      isError: false,
      openNew: false,
      openBoard: false,
      name: '',
      desc: '',
      board: [],
    };
  }

  componentDidMount() {
    this.props.dispatch(actions.getAllBoards());
  }
  validateName = () => {
    let errors = validateEmpty(
      'nameError',
      this.state.name,
      'nameErrorStatus',
      'Board Name is required'
    );
    this.setState({ ...this.state, ...errors });
  };
  validateDesc = () => {
    let errors = validateEmpty(
      'descError',
      this.state.desc,
      'descErrorStatus',
      'Description is required'
    );
    this.setState({ ...this.state, ...errors });
  };
  handleSubmit = (e, action) => {
    if (e) e.preventDefault();
    let isError = false;
    if (action === 'create') {
      this.validateName();
      this.validateDesc();
      if (
        !this.state.name ||
        !this.state.desc ||
        this.state.nameErrorStatus ||
        this.state.descErrorStatus
      ) {
        isError = true;
      }
      this.setState({ isError }, () => {
        if (!this.state.isError) {
          let json = {
            name: this.state.name,
            desc: this.state.desc,
          };
          this.props.dispatch(actions.addBoard(json));
          this.handleClose('openNew');
        }
      });
    }
  };
  handleOpen = prop => {
    this.setState({ [prop]: true });
  };
  handleClose = prop => {
    this.setState({ [prop]: false });
  };
  handleRemove = id => {};
  render() {
    const { classes, loading, boards } = this.props;
    console.log(boards[0]);
    if (loading) {
      return <Loader />;
    } else {
      return (
        <div style={{ padding: '5% 10%' }}>
          <Typography
            component="h3"
            variant="h5"
            className={classes.about_body}
          >
            My Boards
          </Typography>
          <Grid container spacing={24}>
            <Grid item xs={4}>
              <Button
                onClick={() => this.handleOpen('openNew')}
                className={classes.createButton}
                style={{ margin: '20px 0px' }}
              >
                <Icon
                  className={classes.icon}
                  color="disabled"
                  fontSize="large"
                >
                  add_circle
                </Icon>
                Create New Board
              </Button>
            </Grid>
            <Grid item xs={4} />
            <Grid item xs={4} />
          </Grid>
          {/* <Button
            onClick={() => this.handleOpen('openNew')}
            className={classes.createButton}
            style={{ margin: '20px 0px' }}
          >
            <Icon className={classes.icon} color="disabled" fontSize="large">
              add_circle
            </Icon>
            Create New Board
          </Button> */}

          <Grid container spacing={24}>
            {boards.map(board => (
              <Grid item xs={4}>
                <Button
                  key={board.name}
                  className={classes.button}
                  style={{ margin: '15px 0px', maxWidth: '100%' }}
                >
                  <GridList
                    cellHeight={180}
                    className={classes.gridList}
                    cols={6}
                  >
                    <GridListTile cols={6} style={{ height: 'auto' }}>
                      <ListSubheader component="div">
                        <span>{board.name}</span>
                        <span style={{ float: 'right' }}>
                          <MoreVertIcon
                            className={classes.icon}

                            // onClick={() =>
                            //   this.props.dispatch(actions.deleteBoard(board.id))
                            // }
                          />
                        </span>
                      </ListSubheader>
                    </GridListTile>

                    {board.bookmarkDisplayDataList.map((bookmark, id) => {
                      if (board.bookmarkDisplayDataList.length <= 1) {
                        return (
                          <GridListTile
                            key={'a1' + id}
                            cols={4}
                            onClick={() => {
                              this.handleOpen('openBoard');
                              this.setState({ board });
                            }}
                          >
                            {/* <img src={bookmark.imageUrl} alt={bookmark.title} /> */}
                            <img
                              src={bookmark.mainImageUri}
                              alt={bookmark.title}
                            />
                          </GridListTile>
                        );
                      } else if (board.bookmarkDisplayDataList.length <= 3) {
                        return (
                          <GridListTile
                            key={'a3' + id}
                            cols={id < 2 ? 3 : 6}
                            onClick={() => {
                              this.handleOpen('openBoard');
                              this.setState({ board });
                            }}
                          >
                            <img
                              src={bookmark.mainImageUri}
                              alt={bookmark.title}
                            />
                          </GridListTile>
                        );
                      } else if (board.bookmarkDisplayDataList.length <= 5) {
                        return (
                          <GridListTile
                            key={'a5s' + id}
                            cols={id < 2 ? 3 : 2}
                            onClick={() => {
                              this.handleOpen('openBoard');
                              this.setState({ board });
                            }}
                          >
                            <img
                              src={bookmark.mainImageUri}
                              alt={bookmark.title}
                            />
                          </GridListTile>
                        );
                      }
                      return <div />;
                    })}
                  </GridList>
                </Button>
              </Grid>
            ))}
          </Grid>

          <Modal
            aria-labelledby="board-title"
            aria-describedby="board-description"
            open={this.state.openBoard}
            onClose={() => this.handleClose('openBoard')}
          >
            <div style={getModalStyle()} className={classes.paper}>
              <Typography variant="h6">
                <CardsSlider
                  // cards={
                  //   this.state.board ? this.state.board['bookmarks'] : null
                  // }
                  cards={
                    this.props.board ? this.props.board['bookmarks'] : null
                  }
                  className={classes.card}
                  onRemove={this.handleRemove}
                />
              </Typography>
            </div>
          </Modal>
          <Modal
            aria-labelledby="new-board-title"
            aria-describedby="new-board-description"
            open={this.state.openNew}
            onClose={() => this.handleClose('openNew')}
          >
            <form
              style={getModalStyle()}
              className={classes.paper}
              onSubmit={this.handleSubmit}
            >
              <TextField
                // fullWidth
                required
                error={this.state.nameErrorStatus}
                helperText={this.state.nameError}
                value={this.state.name}
                onChange={e =>
                  this.setState({ name: e.target.value }, () =>
                    this.validateName()
                  )
                }
                id="board-name"
                label="Board Name"
                placeholder="Board Name for your bookmarks"
                // className={classes.textField}
                margin="dense"
              />
              <TextField
                fullWidth
                required
                error={this.state.descErrorStatus}
                helperText={this.state.descError}
                value={this.state.desc}
                onChange={e =>
                  this.setState({ desc: e.target.value }, () =>
                    this.validateDesc()
                  )
                }
                id="board-name"
                label="Board Description"
                placeholder="Board Descrition for your bookmarks"
                // className={classes.textField}
                margin="dense"
              />
              <br />
              <Button
                type="submit"
                className={classes.createButton}
                variant="contained"
                onClick={() => this.handleSubmit()}
              >
                Create
              </Button>
            </form>
          </Modal>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(MyBoards));
